import initialState from '../store/initial-state'
import {
    CLEAN_MIDDLE_VIEW_DATA,
    GET_ASSET_DATA,
    GET_ASSET_DATA_SUCCESS,
    GET_ASSET_DATA_FAILURE,
    CLEAN_WAS_DART_UPDATED,
    SET_ASSET_UPDATED_BY_DART
} from '../constants/middleView-types'

export default (state = initialState.middleView, action) => {
    switch (action.type) {

        case CLEAN_MIDDLE_VIEW_DATA:
            return {
                ...state,
                description: null,
                statusAsset: null,
                media: [],
                isFetching: false,
                error: null
            }
        case GET_ASSET_DATA:
            return {
                sFetching: true,
            }

        case GET_ASSET_DATA_SUCCESS:
            const { description, statusAsset, media } = action.payload
            return {
                ...state,
                description: description,
                statusAsset: statusAsset,
                media: media,
                isFetching: false,


            }

        case GET_ASSET_DATA_FAILURE:
            const { error } = action.payload
            return {
                ...state,
                error: error,
                isFetching: false,
            }
        case CLEAN_WAS_DART_UPDATED:
            return {
                ...state,
                wasDartUpdated: false,
                updatedAssetId: null
            }

        case SET_ASSET_UPDATED_BY_DART:
            const { updatedAssetId } = action.payload
            return {
                ...state,
                wasDartUpdated: true,
                updatedAssetId: updatedAssetId
            }
        default:
            return { ...state }
    }

}